module.exports = __webpack_public_path__ + "imgs/LastPrisonerProject.2c82255a91132b31306ed0ad7eb85448.png";